import React from "react";
import { HeroContent, HeroBanner, HeroProvider } from "../../components/pages/Home/Hero/Hero";
import OurMission from "../../components/pages/Home/OurMission/OurMission";
import Process from "../../components/pages/Home/Process/Process";
import WhyReport from "../../components/pages/Home/WhyReport/WhyReport";
import NewsRoom from "../../components/pages/Home/NewsRoom/NewsRoom";
import "./Home.css";

const Home = () => {
  return (
    <div className="home-page">
      <HeroProvider>
        <div className="home-page__grid-section">
          <HeroContent />
        </div>
        <HeroBanner />
      </HeroProvider>
      <OurMission />
      <Process />
      <WhyReport />
      <NewsRoom />
    </div>
  );
};

export default Home;
